import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import SeoHead from "./components/SeoHead";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Treatments from "./pages/Treatments";
import Pictures from "./pages/Pictures";
import Staff from "./pages/Staff";
import AboutUs from "./pages/AboutUs";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Router>
      <SeoHead />
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/behandlingar" element={<Treatments />} />
          <Route path="/bilder" element={<Pictures />} />
          <Route path="/personal" element={<Staff />} />
          <Route path="/om-oss" element={<AboutUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}